import apiClient from "../common/apiClient";

export default class MedicalFeeReceiptDetailController {
  async Create(data, token) {
    try {
      return await apiClient.post("/medical-feeReceipt", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Update(id, data, token) {
    //debugger
    try {
      return await apiClient.put("/medical-feeReceipt/" + id, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Delete(id, token) {
    try {
      return await apiClient.delete("/medical-feeReceipt/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetAllFeeReceipt(token) {
    try {
      return await apiClient.get("/medical-feeReceipts", {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
